export default __webpack_public_path__ + "static/media/marker-black.fd9d38de.svg";